import { render, staticRenderFns } from "./ResultsReport.vue?vue&type=template&id=012a167a"
import script from "./ResultsReport.vue?vue&type=script&lang=js"
export * from "./ResultsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports